"use client";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";

export default function InventoryComp(index){
const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1100);
    handleResize(); // Set initial state
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const boxVariantsL = !isMobile
    ? {
        hidden: { opacity: 0, x: index % 2 === 0 ? 350 : -350 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsR = !isMobile
    ? {
        hidden: { opacity: 0, x: index % 2 === 0 ? -350 : 350 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsPop = !isMobile
    ? {
        hidden: { opacity: 0, scale: 0.2 },
        visible: { opacity: 1, scale: 1, transition: { duration: 1 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsY = !isMobile
    ? {
        hidden: { opacity: 0, y: index % 2 === 0 ? -350 : 350 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

    return(<>
    
       <Row className="mt-5">
            <Col xs={12} md={2}></Col>
            <Col xs={12} className="motion-container">
              {!isMobile ? (
                <motion.div
                  variants={boxVariantsPop}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0 }}
                >
                  <div className="layout11_item fs-20 font-bold">
                    NAU's Inventory Management and Procurement system is an
                    essential tool for any shipping company looking to optimize
                    its supply chain. By gaining complete control over your
                    procurement processes and inventory management, you can
                    reduce costs, improve efficiency, and ensure the smooth
                    operation of your fleet.
                  </div>
                </motion.div>
              ) : (
                <div>
                  <div className="layout11_item fs-20 font-bold">
                    NAU's Inventory Management and Procurement system is an
                    essential tool for any shipping company looking to optimize
                    its supply chain. By gaining complete control over your
                    procurement processes and inventory management, you can
                    reduce costs, improve efficiency, and ensure the smooth
                    operation of your fleet.
                  </div>
                </div>
              )}
            </Col>
            <Col xs={12} md={2}></Col>

            <Col xs={12} className="motion-container mt-5">
              {!isMobile ? (
                <motion.div
                  variants={boxVariantsPop}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0 }}
                >
                  <div className="features1_component-copy text-left m-t-5 ">
                    <div className="features-item-1">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/TargetPeople.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Enhance Visibility
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Gain real-time insights into your entire supply
                            chain, from requisitions received from onboard
                            vessels to inventory levels across your entire
                            fleet.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-2">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Stayaheadofremediationcosts-o.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Optimize Workflows
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Automate requisition and procurement processes,
                            streamlining communication between vessels,
                            shore-based staff, and vendors.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-3">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Key trends.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">Control Costs</h3>
                          </div>
                          <p className="paragraph-11">
                            Benefit from an advanced budgeting engine that
                            empowers informed purchasing decisions and optimizes
                            vendor selection.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-4">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Securepage.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Maintain Inventory Control
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Manage spare parts and stores efficiently, with
                            features like barcode scanning, location-based
                            management, and filtering/exporting capabilities.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ) : (
                <div>
                  <div className="features1_component-copy text-left m-t-5 ">
                    <div className="features-item-1">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/TargetPeople.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Enhance Visibility
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Gain real-time insights into your entire supply
                            chain, from requisitions received from onboard
                            vessels to inventory levels across your entire
                            fleet.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-2">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Stayaheadofremediationcosts-o.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Optimize Workflows
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Automate requisition and procurement processes,
                            streamlining communication between vessels,
                            shore-based staff, and vendors.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-3">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Key trends.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">Control Costs</h3>
                          </div>
                          <p className="paragraph-11">
                            Benefit from an advanced budgeting engine that
                            empowers informed purchasing decisions and optimizes
                            vendor selection.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-4">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Securepage.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Maintain Inventory Control
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Manage spare parts and stores efficiently, with
                            features like barcode scanning, location-based
                            management, and filtering/exporting capabilities.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Row className="mt-5 text-left">
            <Col xs={12} md={7} className="m-t-40 motion-container">
              <h1 className="un-leash-command-subheading text-left">
                Key Features of Our Supply Chain Management System
              </h1>
              {/* <h1 className='un-leash-efficient-subheading m-t-25'>"Essential Features of Inventory Management Systems":</h1> */}
              {!isMobile ? (
                <motion.div
                  variants={boxVariantsL}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0 }}
                >
                  <ul className="list-items list-items-layout2 list-unstyled text-left">
                    <li>
                      Well-structured Stores and Inventory: Organize stores and
                      spare inventory with ease.
                    </li>
                    <li>
                      Traceability and Hierarchy: Strong hierarchical structure
                      for component traceability.
                    </li>
                    <li>
                      {" "}
                      IMPA Code Integration: Option to integrate IMPA Codes for
                      standardization.
                    </li>
                    <li>
                      Flexible Requisition Modes: Various modes for creating
                      service, spares, and store requisitions.
                    </li>
                    <li>
                      Automated Updates: Automated ROB updates and controlled
                      consumption via PMS.
                    </li>
                    <li>
                      Advanced Purchase Cycle: Includes purchase and technical
                      approval functions.
                    </li>
                    <li>
                      {" "}
                      Approval-based Control: Stringent control over purchase
                      order values with a defined hierarchy.
                    </li>
                    <li>
                      {" "}
                      Leave Management and Vessel Re-allocation: Efficient
                      management of leave and vessel re-allocation.
                    </li>
                    <li>
                      {" "}
                      RFQ and Quote Comparisons: Easily maintained RFQs and
                      quote comparisons for multiple vendors.
                    </li>
                    <li>
                      {" "}
                      Multiple Currency Management: Handles transactions in
                      multiple currencies.
                    </li>
                    <li>
                      {" "}
                      Generate POs Without RFQ: For pre-agreed services like 3rd
                      party inspections and audits.
                    </li>
                    <li>
                      {" "}
                      Budget Control: Budgets are maintained and controlled
                      through the system.
                    </li>
                    <li>
                      {" "}
                      Vendor Communication: Various emailers and soft forms for
                      vendor communications.
                    </li>
                    <li>
                      {" "}
                      Vendor Management: Manage and evaluate vendors through the
                      system.
                    </li>
                    <li>
                      {" "}
                      Vendor Portal: Manage RFQs, POs, delivery orders, and
                      invoices.
                    </li>
                    <li>
                      {" "}
                      Integration with Finance and Accounting: Seamless
                      integration with finance and accounting modules.
                    </li>
                  </ul>
                </motion.div>
              ) : (
                <div>
                  <ul className="list-items list-items-layout2 list-unstyled text-left">
                    <li>
                      Well-structured Stores and Inventory: Organize stores and
                      spare inventory with ease.
                    </li>
                    <li>
                      Traceability and Hierarchy: Strong hierarchical structure
                      for component traceability.
                    </li>
                    <li>
                      {" "}
                      IMPA Code Integration: Option to integrate IMPA Codes for
                      standardization.
                    </li>
                    <li>
                      Flexible Requisition Modes: Various modes for creating
                      service, spares, and store requisitions.
                    </li>
                    <li>
                      Automated Updates: Automated ROB updates and controlled
                      consumption via PMS.
                    </li>
                    <li>
                      Advanced Purchase Cycle: Includes purchase and technical
                      approval functions.
                    </li>
                    <li>
                      {" "}
                      Approval-based Control: Stringent control over purchase
                      order values with a defined hierarchy.
                    </li>
                    <li>
                      {" "}
                      Leave Management and Vessel Re-allocation: Efficient
                      management of leave and vessel re-allocation.
                    </li>
                    <li>
                      {" "}
                      RFQ and Quote Comparisons: Easily maintained RFQs and
                      quote comparisons for multiple vendors.
                    </li>
                    <li>
                      {" "}
                      Multiple Currency Management: Handles transactions in
                      multiple currencies.
                    </li>
                    <li>
                      {" "}
                      Generate POs Without RFQ: For pre-agreed services like 3rd
                      party inspections and audits.
                    </li>
                    <li>
                      {" "}
                      Budget Control: Budgets are maintained and controlled
                      through the system.
                    </li>
                    <li>
                      {" "}
                      Vendor Communication: Various emailers and soft forms for
                      vendor communications.
                    </li>
                    <li>
                      {" "}
                      Vendor Management: Manage and evaluate vendors through the
                      system.
                    </li>
                    <li>
                      {" "}
                      Vendor Portal: Manage RFQs, POs, delivery orders, and
                      invoices.
                    </li>
                    <li>
                      {" "}
                      Integration with Finance and Accounting: Seamless
                      integration with finance and accounting modules.
                    </li>
                  </ul>
                </div>
              )}
            </Col>
            <Col xs={12} md={5} className="m-t-40 ">
              <img
                src="/Images/LC/inventoryKifeCycle.png"
                alt="Products"
                className="img-fluid sticky-top"
                style={{
                  boxShadow: "#6b6b6b 1px 1px 4px",
                  borderRadius: "4px",
                }}
              />
            </Col>
          </Row>
          <Row className="mt-5 text-left">
            <Col xs={12} md={7}>
              <img
                src="/Images/Mockups/inv-dashboard-mockupBottom.png"
                alt="Products"
                className="img-fluid sticky-top"
              />
            </Col>
            <Col xs={12} md={5} className="motion-container">
              {!isMobile ? (
                <motion.div
                  variants={boxVariantsR}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0 }}
                >
                  <h1
                    className="un-leash-command-subheading text-left"
                    style={{ paddingTop: "3%" }}
                  >
                    The Challenges of Traditional Procurement
                  </h1>

                  <h1 className="un-leash-efficient-subheading">
                    Managing a complex maritime supply chain can be challenging.
                    Traditional methods often involve:
                  </h1>
                  <ul>
                    <li className="un-leash-paragraph mb-3">
                      <label className="un-leash-paragraph font-bold">
                        Limited visibility:{" "}
                      </label>{" "}
                      Difficulties in tracking requisitions, purchase orders,
                      and inventory levels across various vessels and locations.
                    </li>
                    <li className="un-leash-paragraph mb-3">
                      <label className="un-leash-paragraph font-bold">
                        Inefficient workflows:{" "}
                      </label>{" "}
                      Paper-based processes can lead to delays, errors, and
                      communication breakdowns.
                    </li>
                    <li className="un-leash-paragraph mb-3">
                      <label className="un-leash-paragraph font-bold">
                        Uncontrolled spending:{" "}
                      </label>{" "}
                      Without proper controls, purchasing decisions may not be
                      optimized for cost-effectiveness.
                    </li>
                    <li className="un-leash-paragraph mb-3">
                      <label className="un-leash-paragraph font-bold">
                        Inventory mismanagement:{" "}
                      </label>{" "}
                      Excessive stockpiling or stockouts can significantly
                      impact operations and finances.
                    </li>
                  </ul>
                </motion.div>
              ) : (
                <div>
                  <h1
                    className="un-leash-command-subheading text-left"
                    style={{ paddingTop: "3%" }}
                  >
                    The Challenges of Traditional Procurement
                  </h1>

                  <h1 className="un-leash-efficient-subheading">
                    Managing a complex maritime supply chain can be challenging.
                    Traditional methods often involve:
                  </h1>
                  <ul>
                    <li className="un-leash-paragraph mb-3">
                      <label className="un-leash-paragraph font-bold">
                        Limited visibility:{" "}
                      </label>{" "}
                      Difficulties in tracking requisitions, purchase orders,
                      and inventory levels across various vessels and locations.
                    </li>
                    <li className="un-leash-paragraph mb-3">
                      <label className="un-leash-paragraph font-bold">
                        Inefficient workflows:{" "}
                      </label>{" "}
                      Paper-based processes can lead to delays, errors, and
                      communication breakdowns.
                    </li>
                    <li className="un-leash-paragraph mb-3">
                      <label className="un-leash-paragraph font-bold">
                        Uncontrolled spending:{" "}
                      </label>{" "}
                      Without proper controls, purchasing decisions may not be
                      optimized for cost-effectiveness.
                    </li>
                    <li className="un-leash-paragraph mb-3">
                      <label className="un-leash-paragraph font-bold">
                        Inventory mismanagement:{" "}
                      </label>{" "}
                      Excessive stockpiling or stockouts can significantly
                      impact operations and finances.
                    </li>
                  </ul>
                </div>
              )}
            </Col>
          </Row>
           <Container style={{ padding: "0" }} className=" m-t-40 text-left">
          <Row style={{ margin: "0", padding: "0" }}>
             <Col xs={12} sm={2}></Col>
            <Col xs={12} sm={8} className="text-center">
              <h2 className="font-bold text-center">Frequently Asked Questions</h2>
               <Accordion alwaysOpen className="text-start">
                        <Row className="CommonAccordion m-t-40">
                          <Accordion.Item eventKey="14" className=" mt-2 mb-2">
                            <Accordion.Header>
                             Q1. What does the Inventory module manage?
                            </Accordion.Header>
                            <Accordion.Body>
                             <p>
                            It tracks stock levels, reorders, purchase requests, and delivery logs across fleet and shore.
                             </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="15" className=" mt-2 mb-2">
                            <Accordion.Header>
                            Q2. Can we integrate with ship chandlers and vendors?
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                             Yes, NAU allows integration via API or manual uploads, improving procurement workflow.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="16" className=" mt-2 mb-2">
                            <Accordion.Header>
                          Q3. Is there a budgeting tool built-in?
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                             Yes, users can assign budgets per vessel and monitor spend in real-time.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="17" className=" mt-2 mb-2">
                            <Accordion.Header>
                           Q4. Can NAU prevent overstocking or stockouts?
                            </Accordion.Header>
                            <Accordion.Body>
                             <p>
                         It has reorder thresholds, stock status alerts, and usage analytics to prevent supply issues.
                             </p>
                            </Accordion.Body>
                          </Accordion.Item>
                        
                        </Row>
                      </Accordion>
            </Col>
          </Row>
       </Container>
    </>)
}